import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { modules } from './data/content';
import { CountdownBanner } from './components/CountdownBanner';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Problem } from './components/Problem';
import { SystemIntro } from './components/SystemIntro';
import { ModuleSection } from './components/ModuleSection';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="28sbar1ybx15l">
      <noscript data-id="element-1" data-mp="23u9v6r043jyv">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="23utas12ahw9q" />
      </noscript>
      <CountdownBanner data-id="element-3" data-mp="3mjgclt42snpw" />
      <Hero data-id="element-4" data-mp="3rcj7c4kla37o" />
      <main data-id="element-5" data-mp="3rbzn2h7gv2qh">
        <Testimonials data-id="element-6" data-mp="3rdaselgk8ijp" />
        <Problem data-id="element-7" data-mp="3rd1bdndhtlq5" />
        <section className="bg-cream pb-20 sm:pb-24" aria-label="El sistema y sus 6 módulos" data-id="element-8" data-mp="3reltuemj9e7n">
          <SystemIntro data-id="element-9" data-mp="82jf0klzq9v" />
          <div className="mx-auto mt-12 max-w-[920px] space-y-5 px-5 sm:px-8" data-id="element-10" data-mp="2zld0l5ad579f">
            {modules.map(m => <ModuleSection key={m.number} module={m} data-id="element-11" data-mp="33m5e4aq9pybi" />)}
          </div>
        </section>
        <WhatYouGet data-id="element-12" data-mp="38li8dgjgy7o4" />
        <Bonuses data-id="element-13" data-mp="38l06o4e1f18t" />
        <Offer data-id="element-14" data-mp="38kgm0fx05yr3" />
        <Guarantee data-id="element-15" data-mp="38o4ercumih4r" />
        <Faq data-id="element-16" data-mp="3dkl60fx4dbm2" />
        <FinalCta data-id="element-17" data-mp="3dl4lzr37lpxg" />
      </main>
      <Footer data-id="element-18" data-mp="3dmfo7mh0apmg" />
    </div>;
}